<template>
  <spinner v-if="$apollo.loading" />
  <div v-else>
    <h1 class="title-screen">R1 Invoices</h1>
    <div class="searchbar-container">
      <text-field label="Search" class="searchBar" append-icon="search" @input="onInputChange" />
    </div>

    <v-card class="table elevation-0">
      <v-data-table v-model="tableValue" :headers="headers" :items="filteredInvoices">
        <template slot="items" slot-scope="props">
          <tr>
            <td v-for="header in headers" :key="header.name">
              <div v-if="header.value">
                <span class="data-table-text">{{ props.item[header.value] }}</span>
              </div>
              <div v-else>
                <router-link
                  style="color: #0277bd"
                  target="_blank"
                  :to="{
                    name: routes.ungrouped.invoicepdf,
                    params: {
                      orderUUID: props.item.orderUUID,
                    },
                  }"
                >
                  Prikaži
                </router-link>
              </div>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
import { getEventLegalEntityInvoices } from '@/http'
import moment from 'moment'

export default {
  name: 'legal-entity-invoices-container',
  props: {
    organizationSlug: {
      type: String,
      default: '',
    },
    eventId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      tableValue: [],
      invoices: [],
      filteredInvoices: [],
      headers: [
        {
          text: 'Račun broj',
          align: 'left',
          value: 'invoiceID',
        },
        {
          text: 'Datum plaćanja',
          align: 'left',
          value: 'createdAt',
        },
        {
          text: 'Kupac',
          align: 'left',
          value: 'legalEntity',
        },
        {
          text: '',
          align: 'left',
        },
      ],
    }
  },
  created() {
    this.getLegalEntityInvoices()
  },
  methods: {
    formatDateTime(date) {
      return moment(date).format('DD. MMMM. YYYY HH:mm')
    },
    async getLegalEntityInvoices() {
      const { legalEntityInvoices } = await getEventLegalEntityInvoices(this.eventId)

      legalEntityInvoices.forEach(invoice => {
        this.invoices.push({
          invoiceID: invoice.invoiceNumber != null ? invoice.invoiceNumber : invoice.id,
          createdAt: this.formatDateTime(invoice.createdAt),
          legalEntity: `${invoice.legalEntity.name}, OIB: ${invoice.legalEntity.OIB}`,
          orderUUID: invoice.uuid,
        })
      })
      this.filteredInvoices = this.invoices
    },
    onInputChange(t) {
      const term = t.trim().toLowerCase()

      this.filteredInvoices = this.invoices.filter(inv => {
        return inv.invoiceID == term || inv.legalEntity.toLowerCase().includes(term)
      })
    },
  },
}
</script>
<style scoped>
.searchbar-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: fit-content;
  gap: 1rem;
  margin-top: 2rem;
}

@media screen and (min-width: 992px) {
  .searchbar-container {
    margin-top: 0;
  }
}

.document-container {
  display: flex;
  width: 331px;
  flex-direction: column;
  border-radius: 16px;
  border: 2px solid #d9d9d9;
  align-items: flex-start;
  flex-shrink: 0;
}

.document-header {
  border-radius: 16px 16px 0 0;
  display: flex;
  width: 100%;
  padding: 24px;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
  background: #f5f5f5;
  gap: 1rem;
}

.document-type {
  color: #666;
  font-family: Raleway;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  letter-spacing: -0.72px;
}

.searchbar-container {
  width: 100%;
}

.table {
  border: 2px solid #f5f5f5;
  border-radius: 8px;
}

thead tr {
  background-color: #f5f5f5;
  height: 40px !important;
  border-radius: 8px 8px 0 0;
  border-bottom: none !important;
}

thead tr th {
  font-family: 'Raleway', sans-serif;
  font-size: 14px !important;
  font-weight: bold !important;
  line-height: 1.43 !important;
  color: #666666 !important;
}

tbody tr {
  border-bottom: none !important;
}

tbody tr:hover {
  background: rgba(2, 119, 189, 0.1) !important;
}

.data-table-text {
  font-size: 16px !important;
}

.v-datatable__actions {
  border-top: 2px solid #f5f5f5 !important;
  background: none !important;
  height: 40px;
  flex-wrap: nowrap !important;
}

.v-datatable__actions__select {
  width: 40px;
}

.v-datatable {
  height: 40px;
}

.v-datatable .theme--light.v-text-field:not(.v-input--has-state) .v-input__slot::before,
.v-datatable .theme--light.v-text-field:not(.v-input--has-state) .v-input__slot:hover::before,
.v-datatable
  .theme--light.v-text-field.v-input--is-focused:not(.v-input--has-state)
  .v-input__slot::before {
  border-color: transparent !important;
}
</style>
